/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewArticles_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly articles: ReadonlyArray<{
            readonly photo: {
                readonly serviceId: string | null;
                readonly path: string | null;
            } | null;
            readonly description: string | null;
            readonly title: string | null;
            readonly webLink: {
                readonly url: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "OverviewArticles_tradeFirm";
};
export type OverviewArticles_tradeFirm$data = OverviewArticles_tradeFirm;
export type OverviewArticles_tradeFirm$key = {
    readonly " $data"?: OverviewArticles_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewArticles_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "OverviewArticles_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": null,
          "args": null,
          "concreteType": "DesignFirmArticleType",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photo",
              "storageKey": null,
              "args": null,
              "concreteType": "Photo",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "webLink",
              "storageKey": null,
              "args": null,
              "concreteType": "WebLink",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "url",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '9c974de6c0484e82c3f5fd52ec29e1b8';
export default node;
